/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const CountryTypeDto = {
    Pl: 'PL',
    Sk: 'SK',
    Ro: 'RO',
    Be: 'BE',
} as const;

export type CountryTypeDto = typeof CountryTypeDto[keyof typeof CountryTypeDto];



